<template>
  <div class="page-work-detail-share"
       v-if="work.id > 0"
  >
    <training-introduction :show-bar="render.bottomBar.show && !isMember"
                           :id="training.id"
                           :type="training.type"
                           :title="training.title"
                           :sell="training.sell"
                           :about="training.about"
                           :join-status="training.joinStatus"
                           :show-consult="render.showConsult"
                           :benefit-bar="render.benefitBar"
                           :bottom-bar="render.bottomBar"
                           :primary-price="render.primaryPrice"
                           :my-team-id="groupBuy.myTeamId"
                           :member-wx-group-qr-code="render.memberWxGroupQrCode"
                           join-btn-round
                           @disabled-join="handleDisabledJoin"
                           @joined="handleJoined"
    >
      <header class="work-header-content">
        <div class="user-info">
          <ym-avatar class="user-avatar"
                     :avatar="user.avatar"
                     :name="user.name"
                     size="small"
          />
          <span class="user-name">{{ user.name }}</span>
        </div>
        <div class="motto">{{ level.saying }}</div>
        <div class="work-content-block">
          <dashboard :finish-count="count.finish"
                     :continue-count="count.continue"
                     :read-count="count.read"
          />
          <div class="work-block">
            <h3 class="work-title">第{{ level.seq }}天打卡录音</h3>
            <audio-player class="audio-player"
                          :current="work.id"
                          :source="work.source"
                          :duration="work.duration"
                          type="work"
            />
          </div>
        </div>
      </header>
      <template v-if="isMember"
                #bottom
      >
        <div class="training-btn-block">
          <ym-button class="training-submit-btn training-submit-btn-primary-plain"
                     size="large"
                     @click="handleTrainingDetail"
          >
            查看我的计划
          </ym-button>
        </div>
      </template>

    </training-introduction>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import TrainingIntroduction from '@/pages/Training/components/TrainingIntroduction';
  import { getTrainingWorkShareDetail } from '@/services/training';
  import Dashboard from '@/pages/Training/components/TrainingDashboard';
  import AudioPlayer from '@/components/TrainingPlayer/AudioPlayer';
  import Avatar from '@/components/Avatar';

  export default {
    name: 'PageTrainingWorkDetailShare',
    metaInfo: {
      title: '打卡详情',
    },
    components: {
      TrainingIntroduction,
      Dashboard,
      AudioPlayer,
      'ym-button': Button,
      'ym-avatar': Avatar,
    },
    data() {
      return {
        user: {
          avatar: '',
          name: '',
        },
        level: {
          saying: '',
          seq: 0,
        },
        count: {
          finish: 0,
          continue: 0,
          read: 0,
        },
        work: {
          id: 0,
          duration: 0,
          source: null,
        },
        training: {
          about: '',
          id: 0,
          isMember: false,
          sellStatus: '',
          price: 0,
          sellStartTime: '',
          showBottomBar: false,
          title: '',
        },
        groupBuy: {
          activity: null,
          myTeamId: 0,
        },
        render: {
          benefitBar: {
            show: false,
            desc: '',
            startTime: 0,
            endTime: 0,
          },
          bottomBar: {
            show: false,
            actionBar: {
              type: 'default',
              buttons: [],
            },
            renderPrice: {
              value: 0,
              delete: 0,
              name: '',
            },
          },
          showConsult: false,
          memberWxGroupQrCode: '',
        },
      };
    },
    computed: {
      isMember() {
        return this.training.joinStatus === 'member';
      },
    },
    methods: {
      async fetchData(id) {
        const data = await getTrainingWorkShareDetail(id);
        this.user = data.user;
        this.level = data.level;
        this.count = data.count;
        this.work = data.work;
        this.training = data.training;
        this.groupBuy = data.groupBuy;
        this.render = data.render;
        // 添加返回路径
        this.$route.meta.back = { name: 'TrainingDetail', params: { id: data.training.id } };
      },
      handleJoined() {
        const route = { name: 'TrainingDetail', params: { id: this.training.id } };
        this.$router.push(route);
      },
      handleTrainingDetail() {
        const trainingId = this.training.id;
        const route = { name: 'TrainingDetail', params: { id: trainingId } };
        this.$router.push(route);
      },
      handleDisabledJoin() {
        const { id } = this.$route.params;
        this.fetchData(id);
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchData(id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.fetchData(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-work-detail-share {
    height: 100%;
    overflow: hidden;
  }

  .work-header-content {
    background-color: @color-white;
    padding: @size-base;
  }

  .user-info {
    display: flex;
    align-items: center;
    padding: @size-base;
    margin-bottom: @size-extra-small;
  }

  .user-avatar {
    margin-right: @size-small;
    flex-shrink: 0;
  }

  .motto {
    font-weight: @font-weight-primary;
    line-height: 1.5;
    font-size: @font-size-medium;
    padding: 0 @size-base;
    margin-bottom: @size-medium;
  }

  .work-content-block {
    border-radius: @border-radius-medium;
    background-color: @training-primary-color-lighter;
    padding: @size-medium @size-base;
  }

  .training-btn-block {
    margin: @size-large @size-base;
  }

  .training-dashboard-block {
    padding-bottom: @size-base;
  }

  .work-block {
    border-top: @border-width-base @border-style-base #d5f1ef;
    text-align: center;
  }

  .work-title {
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    padding: @size-base 0;
    margin: 0;
  }
</style>
